import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, FormControl, Grid, TextField, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useColorScheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { sourceResponseAtom } from '../SourceCreate.store';
import useStyles from '../SourceCreate.styles';

const AddAccessCode = () => {
  const { mode: themeMode } = useColorScheme();
  const { classes } = useStyles({ themeMode });
  const { register, setValue, formState } = useFormContext();
  const { errors } = formState;
  const [sourceResponse] = useAtom(sourceResponseAtom);

  useEffect(() => {
    if (sourceResponse?.source_uid) {
      setValue('source_uid', sourceResponse.source_uid);
      setValue('source_name', sourceResponse.source_name || '');
    }
  }, [setValue, sourceResponse]);

  return (
    <Grid container spacing={2}>
      <Grid size={{ md: 12 }}>
        <Typography sx={{ my: 2 }}>
          <strong>Step 1</strong>- Navigate to the following link:
        </Typography>
        <Grid size={{ md: 12 }} sx={{ my: 2 }}>
          <FormControl className={classes.widthFull}>
            <Stack direction="row">
              <a
                className={classes.authorizeUrlLink}
                href={String(
                  sourceResponse?.connection_inputs?.authorize_url || ''
                )}
                target="_blank"
                rel="noopener noreferrer"
              >
                {String(sourceResponse?.connection_inputs?.authorize_url || '')}
              </a>
            </Stack>
          </FormControl>
        </Grid>
        <Typography sx={{ my: 2 }}>
          <strong>Step 2</strong>- Click “Continue” on the next screen. This
          will initiate the process to fetch the data from the registered
          DropBox account
          <br />
        </Typography>

        <Typography sx={{ my: 2 }}>
          <strong>Step 3</strong>- In the following screen, allow the
          permissions (Individual & Team)
          <br />
        </Typography>
        <Typography sx={{ my: 2 }}>
          <strong>Step 4</strong>- Provide the generated access code in the
          below text box:
          <br />
        </Typography>
        <Grid size={{ md: 4 }} sx={{ my: 2 }}>
          <FormControl className={classes.widthFull}>
            <Box className={classes.dFlex}>
              <TextField
                className={classes.widthFull}
                {...register('access_code', {
                  required: 'Access Code is required'
                })}
                placeholder="ENTER ACCESS CODE"
                error={!!errors?.access_code}
              />
              <TextField
                style={{ display: 'none' }}
                type="hidden"
                {...register('source_uid')}
              />
              <TextField
                style={{ display: 'none' }}
                type="hidden"
                {...register('source_name')}
              />
            </Box>
          </FormControl>
        </Grid>

        <Grid size={{ md: 12 }} sx={{ my: 2 }}>
          <Stack direction="row">
            <Stack sx={{ mr: 1 }}>
              <FontAwesomeIcon icon={faInfoCircle} size="lg" />
            </Stack>
            <Box>
              <Typography>
                The source will remain inactive until the access code is
                provided.
                <br />
                The access code can also be provided later using the “Edit”
                option in the respective source.
              </Typography>
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AddAccessCode;
